import { Action, createAction, props } from '@ngrx/store';
import { Message } from '../../models/message';
import { MessageRequest } from '../../models/message-request';
import { MessageResponse } from '../../models/message-response';
import { MessageResponseRequest } from '../../models/message-response-request';

export const getMessages = createAction('[Messages] Get Messages');

export const getMessagesSuccess = createAction(
  '[Messages] Get Messages Success',
  props<{
    messages: Message[];
    pageNumber: number;
    isAtEndOfData: boolean;
    totalRecordCount: number;
  }>()
);

export const getMessagesFailure = createAction('[Messages] Get Messages Failure', props<{ error: unknown }>());

export const setPageNumber = createAction('[Messages] Set Page Number', props<{ pageNumber: number }>());

/**
 * Re-request the page that just failed, without touching `pageNumber` or the loaded entities.
 *
 * Distinct from `getMessages` (which `removeAll`s and restarts at page 1) so the inline error retry
 * does not discard messages the patient has already scrolled through.
 */
export const retryPage = createAction('[Messages] Retry Page');

export const sendMessage = createAction(
  '[Messages] Send Message',
  props<{ messageRequest: MessageRequest; continueAction: Action }>()
);

export const sendMessageSuccess = createAction(
  '[Messages] Send Message Success',
  props<{ message: Message; continueAction: Action }>()
);

export const sendMessageFailure = createAction('[Messages] Send Message Failure', props<{ error: unknown }>());

export const getMessageResponses = createAction('[Messages] Get Message Responses', props<{ messageId: number }>());

export const getMessageResponsesSuccess = createAction(
  '[Messages] Get Message Responses Success',
  props<{ message: Message }>()
);

export const getMessageResponsesFailure = createAction(
  '[Messages] Get Message Responses Failure',
  props<{ error: unknown }>()
);

export const sendMessageResponse = createAction(
  '[Messages] Send Message Response',
  props<{ messageResponseRequest: MessageResponseRequest }>()
);

export const sendMessageResponseSuccess = createAction(
  '[Messages] Send Message Response Success',
  props<{ messageResponse: MessageResponse }>()
);

export const sendMessageResponseFailure = createAction(
  '[Messages] Send Message Response Failure',
  props<{ error: unknown }>()
);

export const selectMessage = createAction('[Messages] Select Message', props<{ messageId: number }>());

export const openNewMessageDialog = createAction('[Messages] Open New Message Dialog');

export const closeNewMessageDialog = createAction('[Messages] Close New Message Dialog');

export const buildNewMessageDraft = createAction(
  '[Messages] Build New Message Draft',
  props<{ providerUserId: string; messageTopicId: number }>()
);

export const discardNewMessageDraft = createAction('[Messages] Discard New Message Draft');

export const clearSelectedMessage = createAction('[Messages] Clear Selected Message');

export const leaveMessagesPage = createAction('[Messages] Leave Messages Page');
